import { render, staticRenderFns } from "./CrudProject.vue?vue&type=template&id=85acddfc&scoped=true"
import script from "./CrudProject.vue?vue&type=script&lang=js"
export * from "./CrudProject.vue?vue&type=script&lang=js"
import style0 from "./CrudProject.vue?vue&type=style&index=0&id=85acddfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85acddfc",
  null
  
)

export default component.exports